/* eslint-disable parog-web/no-glint-expect-error-directive */
import { concat } from '@ember/helper';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import eq from 'ember-truth-helpers/helpers/eq';
import type { Signature as ForcProviderSignature } from 'parog-web/components/forc/provider';

const FamilyMembers = [
  'mother',
  'father',
  'sister',
  'brother',
  'grandmother',
  'grandfather',
  'aunt',
  'uncle',
  'female-cousin',
  'male-cousin'
];

const CancerTypes = ['lung', 'ovarian', 'colon', 'bladder'];

export interface Signature {
  Args: {
    form: ForcProviderSignature['Blocks']['content'][0];
    AlignedFieldsRadioGroup?: unknown;
    patient?: unknown;
    Dropdown?: unknown;
  };
  Blocks: { default: [typeof FamilyMembers] };
}

export default class MedicalHistoryFormAntecedentsComponent extends Component<Signature> {
  eq = eq;

  get cancerTypes(): string[] {
    return CancerTypes;
  }

  get familyMembers(): string[] {
    return FamilyMembers;
  }

  <template>
    {{yield this.familyMembers}}

    <h4 class='ui header'>Autre</h4>

    <div class='field'>
      <@form.ConditionalRadioGroup
        @conditionalValue={{true}}
        @propertyName='otherCancer'
        as |ConditionalRadioGroup showConditionalBlock|
      >
        <div class='field'>
          <ConditionalRadioGroup.AlignedFieldsRadioGroup
            @title='Autre cancers'
            as |Group|
          >
            <Group.FieldRadio @label='Oui' @value={{true}} />
            <Group.FieldRadio @label='Non' @value={{false}} />
          </ConditionalRadioGroup.AlignedFieldsRadioGroup>
        </div>

        {{#if showConditionalBlock}}
          <div class='field'>
            <@form.Dropdown
              @propertyName='otherCancerType'
              @multipleSelection={{true}}
              @allowAdditions={{true}}
              as |dropdown|
            >
              {{#each this.cancerTypes as |cancerType|}}
                <dropdown.Item
                  @key={{cancerType}}
                  @value={{t (concat 'fur.other-cancer-type.' cancerType)}}
                />
              {{/each}}
            </@form.Dropdown>
          </div>
        {{/if}}

      </@form.ConditionalRadioGroup>
    </div>

    {{! @glint-expect-error }}
    {{#if (this.eq @patient.gender 'female')}}
      <div class='field'>
        <@form.AlignedFieldsRadioGroup
          @propertyName='menopause'
          @title='Ménopause'
          as |Group|
        >
          <Group.FieldRadio @label='Oui' @value={{true}} />
          <Group.FieldRadio @label='Non' @value={{false}} />
        </@form.AlignedFieldsRadioGroup>
      </div>
    {{/if}}

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @propertyName='contraception'
        @title='Contraception'
        as |Group|
      >
        <Group.FieldRadio @label='Oui' @value={{true}} />
        <Group.FieldRadio @label='Non' @value={{false}} />
      </@form.AlignedFieldsRadioGroup>
    </div>

    <div class='field'>
      <@form.ConditionalRadioGroup
        @propertyName='smokingPatients'
        @conditionalValue={{true}}
        as |ConditionalRadioGroup showConditionalBlock|
      >
        <div class='field'>
          <ConditionalRadioGroup.AlignedFieldsRadioGroup
            @title='Fumeur'
            as |Group|
          >
            <Group.FieldRadio @label='Oui' @value={{true}} />
            <Group.FieldRadio @label='Non' @value={{false}} />
          </ConditionalRadioGroup.AlignedFieldsRadioGroup>
        </div>

        {{#if showConditionalBlock}}
          <div class='field'>
            <@form.AlignedFieldsRadioGroup
              @propertyName='smokingCessation'
              @title='Sevrage tabagique en cours'
              as |Group|
            >
              <Group.FieldRadio @label='Oui' @value={{true}} />
              <Group.FieldRadio @label='Non' @value={{false}} />
            </@form.AlignedFieldsRadioGroup>
          </div>
        {{/if}}
      </@form.ConditionalRadioGroup>
    </div>
  </template>
}
